/**
 *
 * @param {number} duration
 * @param {*} payload
 * @param {boolean} resolvePromise
 * @return {Promise<unknown>}
 */
export function delay(
  duration = 0,
  payload = undefined,
  resolvePromise = true
) {
  return new Promise((resolve, reject) =>
    setTimeout(() => {
      if (resolvePromise) {
        resolve(payload);
      } else {
        reject(payload);
      }
    }, duration)
  );
}
